import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ScrollSyncContext = /*#__PURE__*/React.createContext();
var Provider = ScrollSyncContext.Provider;

var ScrollSync = /*#__PURE__*/function (_Component) {
  _inherits(ScrollSync, _Component);

  var _super = _createSuper(ScrollSync);

  function ScrollSync(props) {
    var _this;

    _classCallCheck(this, ScrollSync);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "panes", {});

    _defineProperty(_assertThisInitialized(_this), "registerPane", function (node, groups) {
      groups.forEach(function (group) {
        if (!_this.panes[group]) {
          _this.panes[group] = [];
        }

        if (_this.panes[group].length > 0) {
          _this.syncScrollPosition(_this.panes[group][0], node);
        }

        _this.panes[group].push(node);
      });

      _this.addEvents(node, groups);
    });

    _defineProperty(_assertThisInitialized(_this), "unregisterPane", function (node, groups) {
      groups.forEach(function (group) {
        if (_this.findPane(node, group)) {
          _this.removeEvents(node);

          _this.panes[group].splice(_this.panes[group].indexOf(node), 1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addEvents", function (node, groups) {
      /* For some reason element.addEventListener doesnt work with document.body */
      node.onscroll = _this.handlePaneScroll.bind(_assertThisInitialized(_this), node, groups); // eslint-disable-line
    });

    _defineProperty(_assertThisInitialized(_this), "removeEvents", function (node) {
      /* For some reason element.removeEventListener doesnt work with document.body */
      node.onscroll = null; // eslint-disable-line
    });

    _defineProperty(_assertThisInitialized(_this), "findPane", function (node, group) {
      if (!_this.panes[group]) {
        return false;
      }

      return _this.panes[group].find(function (pane) {
        return pane === node;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePaneScroll", function (node, groups, e) {
      var enabled = _this.props.enabled;
      if (_this.props.onScroll) _this.props.onScroll(e);
      if (!enabled) return;
      window.requestAnimationFrame(function () {
        _this.syncScrollPositions(node, groups);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "syncScrollPositions", function (scrolledPane, groups) {
      groups.forEach(function (group) {
        _this.panes[group].forEach(function (pane) {
          /* For all panes beside the currently scrolling one */
          if (scrolledPane !== pane) {
            /* Remove event listeners from the node that we'll manipulate */
            _this.removeEvents(pane, group);

            _this.syncScrollPosition(scrolledPane, pane);
            /* Re-attach event listeners after we're done scrolling */


            window.requestAnimationFrame(function () {
              _this.addEvents(pane, groups);
            });
          }
        });
      });
    });

    _this.syncContext = {
      registerPane: _this.registerPane,
      unregisterPane: _this.unregisterPane
    };
    return _this;
  }

  _createClass(ScrollSync, [{
    key: "syncScrollPosition",
    value: function syncScrollPosition(scrolledPane, pane) {
      var scrollTop = scrolledPane.scrollTop,
          scrollHeight = scrolledPane.scrollHeight,
          clientHeight = scrolledPane.clientHeight,
          scrollLeft = scrolledPane.scrollLeft,
          scrollWidth = scrolledPane.scrollWidth,
          clientWidth = scrolledPane.clientWidth;
      var scrollTopOffset = scrollHeight - clientHeight;
      var scrollLeftOffset = scrollWidth - clientWidth;
      var _this$props = this.props,
          proportional = _this$props.proportional,
          vertical = _this$props.vertical,
          horizontal = _this$props.horizontal;
      /* Calculate the actual pane height */

      var paneHeight = pane.scrollHeight - clientHeight;
      var paneWidth = pane.scrollWidth - clientWidth;
      /* Adjust the scrollTop position of it accordingly */

      if (vertical && scrollTopOffset > 0) {
        pane.scrollTop = proportional ? paneHeight * scrollTop / scrollTopOffset : scrollTop; // eslint-disable-line
      }

      if (horizontal && scrollLeftOffset > 0) {
        pane.scrollLeft = proportional ? paneWidth * scrollLeft / scrollLeftOffset : scrollLeft; // eslint-disable-line
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/React.createElement(Provider, {
        value: this.syncContext
      }, React.Children.only(children));
    }
  }]);

  return ScrollSync;
}(Component);

_defineProperty(ScrollSync, "defaultProps", {
  proportional: true,
  vertical: true,
  horizontal: true,
  enabled: true
});

export default ScrollSync;
export { ScrollSyncContext };
//# sourceMappingURL=ScrollSync.js.map
